export default __webpack_public_path__ + "static/media/banner-contact.2418b85d.png";